import _get from 'lodash-es/get';
import { put } from 'redux-saga/effects';
import {
  authCheckFailed,
  authCheckSuccess,
  refreshAuthFailed,
  refreshAuthSuccess,
  setCurrentUser,
} from '../../actions/auth';
import {
  GET_AUTH_CHECK,
  GET_AUTH_VALIDATE,
  GET_SPOC_VALIDATE,
  SET_SPOC_INVITE,
} from '../../constants/urls';
import { isUserLoggedIn } from '../../helpers';
import { genericErrorMsg } from '../../pages/common/components/constants';
import zfetch, {
  METHOD_GET,
  METHOD_POST,
} from '../../pages/common/utils/zfetch';
import { openErrorToast } from '../../reducers/uiLogic';

let initialCall = true;

const authenticate = () => {
  const options = {
    method: METHOD_GET,
  };
  return zfetch(GET_AUTH_CHECK, options);
};

const authValidate = () => {
  const options = {
    method: METHOD_POST,
  };
  return zfetch(GET_AUTH_VALIDATE, options);
};

const spocInviteValidate = inviteID => {
  const options = {
    method: METHOD_POST,
    body: JSON.stringify(inviteID),
  };
  return zfetch(GET_SPOC_VALIDATE, options);
};

const spocInviteAccept = inviteID => {
  const options = {
    method: METHOD_POST,
    body: JSON.stringify(inviteID),
  };
  return zfetch(SET_SPOC_INVITE, options);
};

function* handleSpocInviteValidate(inviteId) {
  const spocValidateResponse = yield spocInviteValidate({
    inviteId,
  });
  const validateJson = yield spocValidateResponse.json();
  const { status, message, isAccepted } = validateJson;
  if (!status) {
    const err = new Error(message.title);
    err.name = 'SpocInviteAcceptError';
    throw err;
  }
  return { status, isAccepted };
}

function* handleSpocInviteAccept(inviteId) {
  const spocInviteAcceptResponse = yield spocInviteAccept({
    inviteId,
  });
  const spocValidateJson = yield spocInviteAcceptResponse.json();
  const { status, message } = spocValidateJson;
  if (!status) {
    const err = new Error(message.title);
    err.name = 'SpocInviteAcceptError';
    throw err;
  }
}

function* handleAuthenticate() {
  try {
    const response = yield authenticate();
    const jsonResponse = yield response.json();
    const { status = false, data } = jsonResponse;
    const isLoggedIn = isUserLoggedIn(data);
    if (isLoggedIn && status) {
      initialCall = false;
      yield put(setCurrentUser(data));
      yield put(authCheckSuccess(data));
    } else {
      const failedMessage = _get(data, 'message.title', genericErrorMsg);
      if (!initialCall) yield put(openErrorToast(failedMessage));

      initialCall = false;
      yield put(authCheckFailed());
    }
  } catch (error) {
    let err = error;
    if (error.response) {
      err = yield err.response;
    }
    yield put(openErrorToast());
    yield put(authCheckFailed(err));
  }
}

export function* getRefeshAuthSaga() {
  try {
    const response = yield authenticate();
    const jsonResponse = yield response.json();
    const { status = false, data } = jsonResponse;
    const isLoggedIn = isUserLoggedIn(data);
    if (isLoggedIn && status) {
      initialCall = false;
      yield put(setCurrentUser(data));
    } else {
      const failedMessage = _get(data, 'message.title', genericErrorMsg);
      yield put(openErrorToast(failedMessage));
    }
  } catch (error) {
    let err = error;
    if (error.response) {
      err = yield err.response;
    }
    yield put(refreshAuthFailed(err));
  }
  yield put(refreshAuthSuccess());
}

function* getAuthCheckSaga() {
  try {
    const query = new URLSearchParams(window.location.search);
    const inviteId = query.get('invite');
    let validInviteId = false;
    let inviteAccepted = false;
    const validateResponse = yield authValidate();
    const validateJson = yield validateResponse.json();
    const { status: authStatus = false } = validateJson;
    if (inviteId) {
      const { status, isAccepted } = yield* handleSpocInviteValidate(inviteId);
      validInviteId = status;
      inviteAccepted = isAccepted;
    }
    if (authStatus.status === 'success' && validInviteId && !inviteAccepted) {
      yield* handleSpocInviteAccept(inviteId);
    }

    if (authStatus.status === 'success') {
      yield* handleAuthenticate();
    } else {
      const failedMessage = _get(authStatus, 'message', genericErrorMsg);

      if (!initialCall) yield put(openErrorToast(failedMessage));

      initialCall = false;
      yield put(authCheckFailed());
    }
  } catch (error) {
    let err = error;
    let errorMessage = genericErrorMsg;
    if (error.response) {
      err = yield err.response;
    }
    if (error.name === 'SpocInviteError') {
      initialCall = false;
      errorMessage = _get(error, 'message', genericErrorMsg);
    }
    if (!initialCall) yield put(openErrorToast(errorMessage));

    initialCall = false;

    yield put(authCheckFailed(err));
  }
}

export default getAuthCheckSaga;
